"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kelvinToCelsius = void 0;
const kelvinToCelsius = (kelvin) => {
    return `${Math.round(kelvin - 273.15)}°C`;
};
exports.kelvinToCelsius = kelvinToCelsius;
